<span 
    id="typewriter" 
    [class.color]="color === 'primary'" [ngStyle]="{'color': (color != 'primary') ? '#' + color : '' }"
    ngStyle.xs="display: block;"
>
{{ word }}</span>